import { getSingletonFactorAssetByType } from 'tools/factorAssets'
import { FactorAssetInfo } from 'types/factor'
import styles from './MenuBar.module.scss'
import { isDefined } from 'tools/common'
import { DrawerHeader } from 'theme/themeOverride'
import { Icon } from 'components/ui'

type NavigationImageComponentProps = {
  open: boolean
}

export const NavigationImageComponent = (props: NavigationImageComponentProps) => {
  const { open } = props
  const hostName = window.location.hostname
  const navigationSideBarImage: FactorAssetInfo | undefined = getSingletonFactorAssetByType(
    'NAVIGATION_SIDE_BAR_IMAGE',
    hostName
  )
  const navigationSideBarCollapsedImage: FactorAssetInfo | undefined = getSingletonFactorAssetByType(
    'NAVIGATION_SIDE_BAR_COLLAPSED_IMAGE',
    hostName
  )

  const currentNavigationImage = open
    ? navigationSideBarImage || navigationSideBarCollapsedImage
    : navigationSideBarCollapsedImage || navigationSideBarImage
  const currentNavigationImageAlt =
    currentNavigationImage === navigationSideBarCollapsedImage
      ? 'Navigation Sidebar Collapsed Logo'
      : 'Navigation Sidebar Logo'

  return (
    <>
      {isDefined(currentNavigationImage) ? (
        <DrawerHeader>
          <div
            className={`${styles.navigationImageContainer} ${
              open ? styles.navigationImageContainerOpen : styles.navigationImageContainerCollapsed
            }`}
          >
            <img
              src={currentNavigationImage?.assetUrl}
              alt={currentNavigationImageAlt}
              className={styles.navigationImage}
            />
          </div>
        </DrawerHeader>
      ) : (
        <DrawerHeader>
          <Icon name={open ? 'factorcloud-new' : 'logo_new'} width={200} height={45} />
        </DrawerHeader>
      )}
    </>
  )
}
